<script setup lang="ts">
import { useNuxtApp } from "#app";

const props = defineProps({
    content: Object,
});

const text = useNuxtApp().useMarked().parse(props.content?.text);
</script>

<template>
    <div class="text-base w-[100%] leading-7 mb-4 mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10 mx-auto">
        <div class="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
            <div class="lg:pr-4">
                <div class="lg:max-w-lg">
                    <p v-if="content.smallTitle" class="font-semibold leading-7 text-indigo-600">{{ content.smallTitle }}</p>
                    <h2 v-if="content.bigTitle" class="mt-2 tracking-tight text-gray-900 dark:text-white">{{ content.bigTitle }}</h2>
                    <div class="mt-6 text-xl leading-8" v-html="text"></div>
                </div>
            </div>
        </div>
        <div class="lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
            <img class="w-[100%] lg:w-auto lg:h-[100%] max-h-[100%] max-w-[100%] rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10" :src="content.image" :alt="content.bigTitle">
        </div>
    </div>
</template>